import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './testimonial.css';

const testimonials = Array(6).fill({
  highlight: '“Pivot creates innovative design solutions that inspire.”',
  fullTestim:
    'Collaborate with a digital design agency that will make you proud. Collaborate with a digital design agency that will make you proud. Collaborate with a digital design...',
  name: 'Michael David',
  company: 'SkyPulse',
  imgSrc: 'https://pivotcreat4stg.wpenginepowered.com/wp-content/uploads/2025/04/testimexample.png',
});

const Testimonial = ({ testimonial }) => {
  return (
    <motion.div
      className="testimonial expanded addContent"
      role="button"
      tabIndex={0}
      aria-expanded="true"
      aria-label={`Read testimonial from ${testimonial.name} at ${testimonial.company}`}
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
      transition={{ duration: 0.5 }}
    >
      <div className="testim_content">
        <p className="highlight">
          <i>{testimonial.highlight}</i>
        </p>
        <p className="full_testim">{testimonial.fullTestim}</p>
        <p className="name">{testimonial.name}</p>
        <p className="company">{testimonial.company}</p>
      </div>
      <img src={testimonial.imgSrc} alt={`Photo of ${testimonial.name}`} />
    </motion.div>
  );
};

const TestimonialBox = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="testimonial_box">
      <AnimatePresence mode="wait">
        <Testimonial key={current} testimonial={testimonials[current]} />
      </AnimatePresence>
    </section>
  );
};

export default TestimonialBox;
